import React from 'react';
import {Match, MatchRenderFn} from '@reach/router';
import {RouteStringValues} from 'routing/route';

interface Props {
    route: RouteStringValues;
    onLinkMatch: MatchRenderFn<{}>;
}

export const LinkActivityMatcher = React.memo<Props>(({route, onLinkMatch}) => (
    <Match path={route}>
        {
            onLinkMatch
        }
    </Match>
));
